import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, updateDoc } from 'firebase/firestore';
import { db, storage } from '../firebase';
import dexie from '../offlineDB';

export async function syncTuneRecordings(tune, user) {
  if (!navigator.onLine || !user || !tune?.recordings?.length) return;

  const updatedRecordings = [];

  for (const rec of tune.recordings) {
    if (rec.url || !rec.localBlob) {
      updatedRecordings.push(rec); // Already synced or not a recording blob
      continue;
    }

    try {
      const storagePath = `recordings/${user.uid}/${tune.id}/${rec.id}.webm`;
      const storageRef = ref(storage, storagePath);
      await uploadBytes(storageRef, rec.localBlob);
      const url = await getDownloadURL(storageRef);

      const cleaned = {
        id: rec.id,
        label: rec.label,
        duration: rec.duration,
        createdAt: rec.createdAt,
        url,
        storagePath
      };

      updatedRecordings.push(cleaned);
    } catch (err) {
      console.error(`Failed to sync recording ${rec.id}:`, err);
      updatedRecordings.push(rec); // Preserve unsynced version with localBlob
    }
  }

  // ✅ Firestore-safe version with no blobs
  const safeForFirebase = updatedRecordings.map(r => ({
    id: r.id,
    label: r.label,
    duration: r.duration,
    createdAt: r.createdAt,
    url: r.url || null,
    storagePath: r.storagePath || null
  }));

  const tuneRef = doc(db, 'users', user.uid, 'tunes', tune.id);
  await updateDoc(tuneRef, { recordings: safeForFirebase });

  // ✅ Dexie can still keep localBlob for retry
  await dexie.tunes.update(tune.id, { recordings: updatedRecordings });
}
